import * as Sentry from '@sentry/browser';

export function configSentry() {
	return Sentry.init({
		dsn: process.env.REACT_APP_ERROR_REPORTING_KEY,
		environment: process.env.NODE_ENV,
	});
}
